import { render, staticRenderFns } from "./SupplierReturn.vue?vue&type=template&id=17bb0bd5&"
import script from "./SupplierReturn.vue?vue&type=script&lang=js&"
export * from "./SupplierReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports